import { StorageWrapper } from './StorageWrapper.ts';
import { UIDeviceController } from './ui_html/UIDeviceController.ts';
// TODO DO NOT add new user or request specific variables, use the client user state: https://github.com/colonistio/katan/issues/17254
export class UIUtilsEjsVariables {
}
// Configuration camelCase
UIUtilsEjsVariables.language = window.language;
UIUtilsEjsVariables.isProduction = window.isProduction;
UIUtilsEjsVariables.freeMap = window.freeMap;
UIUtilsEjsVariables.onlineCount = window.onlineCount;
UIUtilsEjsVariables.gamesToday = window.gamesToday;
UIUtilsEjsVariables.discordChannelUrl = window.discordChannelUrl;
UIUtilsEjsVariables.socketDebugActive = window.socketDebugActive;
UIUtilsEjsVariables.ejsSocketServerWss = window.socketServerWSS;
UIUtilsEjsVariables.logRocketId = window.logRocketId;
UIUtilsEjsVariables.vliPrerollId = window.vliPreRoll;
UIUtilsEjsVariables.isUserOnDiscord = window.isUserOnDiscord;
UIUtilsEjsVariables.discordSDKClientId = window.discordSDKClientId;
UIUtilsEjsVariables.isUserOnMobileWebBrowser = UIDeviceController.isUserOnMobileWebBrowser();
UIUtilsEjsVariables.isUserOnMobileAppOrWeb = UIDeviceController.isUserOnMobileAppOrWeb();
UIUtilsEjsVariables.isUserOnMobile = window.isUserOnMobile;
UIUtilsEjsVariables.isUserOnTabletApp = UIDeviceController.isUserOnTabletApp();
UIUtilsEjsVariables.isUserOnDiscordMobile = window.isUserOnDiscordMobile || UIDeviceController.isUserOnDiscordMobile();
UIUtilsEjsVariables.shouldDisplayNewMobileGameUI = StorageWrapper.isPortraitGamePlayEnabled();
UIUtilsEjsVariables.discordSKUIds = window.discordSKUIds;
UIUtilsEjsVariables.versionNumber = window.versionNumber;
UIUtilsEjsVariables.analyticsActive = window.analyticsActive;
UIUtilsEjsVariables.canPurchaseCoinsOnDiscord = window.canPurchaseCoinsOnDiscord;
UIUtilsEjsVariables.showConsoleLogUI = window.showConsoleLogUI;
UIUtilsEjsVariables.showVliAdAtBottomInGame = window.showVliAdAtBottomInGame;
UIUtilsEjsVariables.frontendSentryDSN = window.frontendSentryDSN;
UIUtilsEjsVariables.mobileAppSentryDSN = window.mobileAppSentryDSN;
UIUtilsEjsVariables.frontendSentryEnvironment = window.frontendSentryEnvironment;
UIUtilsEjsVariables.frontendSentryTraceSampleRate = window.frontendSentryTraceSampleRate;
UIUtilsEjsVariables.vliPublicKey = window.vliPublicKey;
UIUtilsEjsVariables.vliAdvKey = window.vliAdvKey;
UIUtilsEjsVariables.supportEmail = window.supportEmail;
UIUtilsEjsVariables.shouldHideStoreOnMobile = window.shouldHideStoreOnMobile && UIDeviceController.isUserOnMobileAppOrWeb();
UIUtilsEjsVariables.shouldHideAdsOnMobile = window.shouldHideAdsOnMobile;
UIUtilsEjsVariables.hotjarTrackingCode = window.hotjarTrackingCode;
UIUtilsEjsVariables.shouldEnableNativeIOSPaymentsOnMobile = window.shouldEnableNativeIOSPaymentsOnMobile;
UIUtilsEjsVariables.shouldEnableNativeAndroidPaymentsOnMobile = window.shouldEnableNativeAndroidPaymentsOnMobile;
UIUtilsEjsVariables.shouldEnableIOSDoubleTapPaymentOnMobile = window.shouldEnableIOSDoubleTapPaymentOnMobile;
UIUtilsEjsVariables.shouldEnableAndroidDoubleTapPaymentOnMobile = window.shouldEnableAndroidDoubleTapPaymentOnMobile;
UIUtilsEjsVariables.shouldEnableDoubleTapPaymentForExternalUsersOnMobile = window.shouldEnableDoubleTapPaymentForExternalUsersOnMobile;
UIUtilsEjsVariables.mobileDoubleTapPaymentTestCardMode = window.mobileDoubleTapPaymentTestCardMode;
UIUtilsEjsVariables.isPushNotificationsEnabled = window.isPushNotificationsEnabled;
UIUtilsEjsVariables.rankedPrerollAdsEnabled = window.rankedPrerollAdsEnabled;
UIUtilsEjsVariables.showUpdateAppPopupForVersion = window.showUpdateAppPopupForVersion;
UIUtilsEjsVariables.shouldDisableStoreOnAndroidMobile = window.shouldDisableStoreOnAndroidMobile;
UIUtilsEjsVariables.shouldDisableIAPForExternalUsersOnMobile = window.shouldDisableIAPForExternalUsersOnMobile;
UIUtilsEjsVariables.discordActivityMobileOrientation = window.discordActivityMobileOrientation;
UIUtilsEjsVariables.helplyWidgetId = window.helplyWidgetId;
